//#region src/themes/types.ts
/**
* The attributes that apply a pack: set them together on one element (<html> in the
* app, the wrapper in Storybook), because tokens resolve where these are set.
*/
function brandAttributes(pack, { mode, density }) {
	return {
		"data-brand": pack.id,
		"data-theme": pack.modes.includes(mode) ? mode : pack.modes[0] ?? "light",
		"data-density": density ?? pack.density
	};
}
//#endregion
export { brandAttributes };

//# sourceMappingURL=types.js.map